import React from 'react';
import { MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ChatIconProps {
  className?: string;
  iconClassName?: string;
  unreadCount: number;
  onClick: () => void;
  isOpen: boolean;
}

export const ChatIcon: React.FC<ChatIconProps> = ({
  className,
  iconClassName = 'w-6 h-6',
  unreadCount,
  onClick,
  isOpen,
}) => {
  return (
    <div className="relative">
      <button
        onClick={onClick}
        className={cn(
          'relative text-gray-300 hover:text-white transition-colors duration-200',
          'focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-gray-900',
          'rounded-full hover:bg-gray-800',
          isOpen && 'text-red-400 bg-gray-800',
          className,
        )}
        aria-label={`Messages (${unreadCount} unread)`}
        tabIndex={0}
      >
        <MessageCircle className={iconClassName} />

        {unreadCount > 0 && (
          <div className="absolute -top-1 -right-1">
            <div className="bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center min-w-[20px]">
              {unreadCount > 99 ? '99+' : unreadCount}
            </div>
          </div>
        )}
      </button>
    </div>
  );
};
